import Structure from "../Structure";

/*
    Map structures are structures that can be found in the map data
 */
abstract class MapStructure extends Structure {}

export default MapStructure;
